export enum ESeanceOptionModification {
  Seance = 'seance',
  AllSeances = 'allSeance',
  OnlyFutur = 'onlyFutur'
}